import { render, staticRenderFns } from "./ViewInspectionComponent.vue?vue&type=template&id=3d86e604"
import script from "./ViewInspectionComponent.vue?vue&type=script&lang=js"
export * from "./ViewInspectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports